module.exports = __webpack_public_path__ + "7237318ac1b2388fbf6ffa2e1623c16d.svg";